/* eslint-disable @typescript-eslint/no-empty-object-type */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare interface IStorageKey<T> {}

export type StorageKey<T extends {} = {}> = IStorageKey<T> & string

type ExtractType<K> = K extends StorageKey<infer T> ? T : {}

const singl_localStorage =
  typeof window !== 'undefined' && window.localStorage
    ? window.localStorage
    : { setItem: () => {}, getItem: () => {}, removeItem: () => {} }

export function setLocalStorageJSON<K extends StorageKey>(key: K, data: ExtractType<K>): void {
  singl_localStorage.setItem(key, JSON.stringify(data))
}

export function getLocalStorageJSON<K extends StorageKey>(key: K): ExtractType<K> | null {
  const itemFromLocalStorage = singl_localStorage.getItem(key)
  return itemFromLocalStorage ? JSON.parse(itemFromLocalStorage) : null
}

export function removeLocalStorage<K extends StorageKey>(key: K): void {
  singl_localStorage.removeItem(key)
}

export function getLocalStorage<K extends StorageKey>(key: K): string | null {
  const itemFromLocalStorage = singl_localStorage.getItem(key)
  return itemFromLocalStorage ? itemFromLocalStorage : null
}

export function setLocalStorage<K extends StorageKey>(key: K, data: string): void {
  singl_localStorage.setItem(key, data)
}
